import React from "react";

function HeroSection() {
  return (
    <section className="relative w-full min-h-[80vh] flex items-center justify-center bg-gradient-to-br from-purple-1 to-blue-2 text-white overflow-hidden">
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_#00FF84_0%,_transparent_60%)]" />
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h1
          className="text-title font-extrabold leading-tight"
        >
          Summer Maker Stage <br />
          <span className="text-green-1">Coding Bootcamp</span>
        </h1>
        <p
          className="mt-6 text-subtitle max-w-2xl mx-auto text-light-3"
        >
          Une immersion unique de 4 semaines pour apprendre à coder en Python, 
          comprendre le web et découvrir l'intelligence artificielle.
        </p>
        
        <div className="mt-8 bg-white/10 backdrop-blur-sm rounded-xl p-4 max-w-md mx-auto">
          <p className="font-semibold mb-2">🎯 Programme adapté pour:</p>
          <div className="flex flex-wrap justify-center gap-4">
            <span className="bg-white/20 px-3 py-1 rounded-full">👦 12-15 ans</span>
            <span className="bg-white/20 px-3 py-1 rounded-full">👨‍🎓 16-18 ans</span>
            <span className="bg-white/20 px-3 py-1 rounded-full">👨‍💼 Adultes</span>
          </div>
        </div>
        
        <a
          href="https://tally.so/r/3y5Xx4"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-10 px-8 py-4 bg-red-4 rounded-full text-button text-white border-2 border-red-4
          hover:bg-transparent transition"
        >
          S'inscrire maintenant
        </a>
      </div>
    </section>
  );
}

export default HeroSection;